import { Controller } from "@hotwired/stimulus";
import { Notyf } from "notyf";

export default class extends Controller {
  static values = {
    //thing: String,
    messageType: String,
    message: String,
  };

  static targets = ["message"];

  initialize() {
    this.notyf = new Notyf({
      duration: 3250,
      position: {
        x: "right",
        y: "top",
      },
      types: [
        {
          type: "success",
          background: "#559d67",
        },
        {
          type: "error",
          background: "#e35b45",
        },
      ],
    });
  }

  connect() {
    this.messageTargets.forEach((element) => {
      const message = element.dataset.message
      const messageType = element.dataset.messageType
      if (messageType == "notice") {
        this.notice(message);
      } else if (messageType == "alert") {
        this.alert(message);
      }
    });
  }

  notice(message) {
    this.notyf.success(message);
  }

  alert(message) {
    this.notyf.error(message);
  }
}
